import { useEffect, useState } from 'react'

export function useIsAtBottom() {
  const [isAtBottom, setIsAtBottom] = useState(false)

  useEffect(() => {
    const wrapper = document.querySelector('#app-wrapper')

    if (!wrapper) return

    const isScrolledToBottom = (): boolean => {
      const scrollHeight = wrapper.scrollHeight

      const scrollTop = wrapper.scrollTop

      const clientHeight = wrapper.clientHeight

      return Math.abs(scrollHeight - scrollTop - clientHeight) < 1
    }

    const handleScroll = () => {
      setIsAtBottom(isScrolledToBottom())
    }

    wrapper.addEventListener('scroll', handleScroll)

    handleScroll()

    return () => wrapper.removeEventListener('scroll', handleScroll)
  }, [])

  return { isAtBottom }
}
